// @flow
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { withHelmet } from 'infrastructure/seo/Helmet';
import { dynamicClassName } from 'utils/dynamicClassName';
import type { TeamList } from 'types/TeamList';
import type { BlocContent } from 'types/NewsletterBloc';
import type { StaffType, StaffFiltersSearchType } from 'types/Staff';
import { nullStaffsFiltersSearch } from 'types/Staff';
import type { Status } from 'types/Status';
import type { SeasonListType } from 'types/Seasons';
import { convertObjectToQueryString, convertQueryStringToTeam } from 'utils/urlUtils';
import { objectFilterTitle } from 'utils/filterUtils';

import { STATUS_LOADING, STATUS_SUCCESS } from 'constants/statusConstants';
import Loading from 'components/fragments/Loading';
import Breadcrumb from 'components/fragments/Breadcrumb';
import CardPlayer from 'containers/fragments/card/CardPlayerContainer';
import Sidebar from 'components/sidebar/Sidebar';
import TeamStaffsFilters from 'components/team/TeamStaffsFilters';
import TeamMenuDropdownMenu from 'components/teammenu/TeamMenuDropdownMenu';
import { teamSubmenuHeaders } from 'constants/menuConstants';
import SubMenuHeader from 'components/header/SubMenuHeader';
//import { parionsSportLink } from 'constants/parionsSportsConstant';
import { getMetaBySlug } from 'utils/seoUtils';

export type StateProps = {
  title: string,
  excerpt: string,
  featured_media: {
    src: string,
    legend: string
  },
  sidebar_content: BlocContent[],
  staffs: StaffType[],
  staffsFetchStatus: Status,
  status: Status,
  seasons: SeasonListType[],
  searchedStaff: string,
  defaultSeason: string,
  teamlist: TeamList[],
  redirect_competitions: string,
  redirect_resultats: string
};

export type DispatchProps = {
  fetchPageList: (slug: string) => void,
  fetchStaffsTeam: (filters: StaffFiltersSearchType) => void,
  searchStaff: (searchedStaff: string) => void,
  initialFetchStaffsTeam: (filters: StaffFiltersSearchType) => void,
  fetchTeamList: () => void,
  resetStaff: () => void
};

type State = {
  poste: Array<number>,
  timestamp: any
};

type Props = {
  match: any,
  history: any,
  location: any
} & DispatchProps &
  StateProps;

class TeamStaffs extends Component<Props, State> {
  props: Props;
  state: State = {
    poste: [],
    timestamp: ''
  };

  _onFilterChange = (filters: StaffFiltersSearchType, filterType: string) => {
    const {
      history,
      fetchStaffsTeam,
      defaultSeason,
      seasons,
      match: {
        params: { slug }
      }
    } = this.props;
    if (!filters.season) {
      const saison = seasons.filter(season => {
        return season.name === defaultSeason;
      });
      filters.season = saison[0].id;
    }
    if (filterType && filterType === 'poste') {
      this.setState({ poste: filters.poste ? filters.poste : [] });
    } else {
      fetchStaffsTeam({ ...filters, equipe: slug });
    }
    history.replace({
      search: convertObjectToQueryString(filters)
    });
  };

  getFiltersOnQuery = () => {
    const {
      location: { search }
    } = this.props;
    if (search !== '') {
      return convertQueryStringToTeam(search);
    } else {
      return nullStaffsFiltersSearch;
    }
  };

  componentDidMount() {
    const {
      match: {
        params: { slug }
      },
      initialFetchStaffsTeam,
      fetchPageList,
      searchStaff,
      fetchTeamList,
      resetStaff
    } = this.props;

    const filters = this.getFiltersOnQuery();

    initialFetchStaffsTeam({ ...filters, equipe: slug });
    fetchPageList(slug);
    searchStaff('');
    fetchTeamList();
    resetStaff();
    this.setState({
      poste: filters.poste ? filters.poste : []
    });
  }

  renderStaffsByPoste = (poste: Object) => {
    const { staffs, searchedStaff } = this.props;
    const restCards = staffs.length % 3;
    const filteredStaffs = objectFilterTitle(staffs, searchedStaff);

    return filteredStaffs.map((card, index) => {
      const isOnLastLine =
        (restCards === 0 && index >= staffs.length - 3) || (restCards !== 0 && index >= staffs.length - restCards);

      const classNameContainer = dynamicClassName('col col-md-6 col-lg-4 mb-1 mb-md-3');
      isOnLastLine ? classNameContainer.add('mb-lg-0') : classNameContainer.add('mb-lg-4');
      if (card.poste.name === poste) {
        return (
          <div key={index} className={classNameContainer.build()}>
            <CardPlayer
              slug={null}
              title={card.title}
              poste={card.poste.name}
              featured_media={card.featured_media}
              noTextOverflow
            />
          </div>
        );
      } else {
        return false;
      }
    });
  };

  renderStaffsByPosteGroup = (poste: Object) => {
    const { staffs, searchedStaff } = this.props;
    const restCards = staffs.length % 3;
    let filteredStaffs = objectFilterTitle(staffs, searchedStaff);

    if (this.state.poste && this.state.poste.length > 0) {
      filteredStaffs = filteredStaffs.filter(staff => {
        return this.state.poste.indexOf(staff.poste.id) !== -1;
      });
    }

    return filteredStaffs.map((card, index) => {
      const isOnLastLine =
        (restCards === 0 && index >= staffs.length - 3) || (restCards !== 0 && index >= staffs.length - restCards);

      const classNameContainer = dynamicClassName('col col-md-6 col-lg-4 mb-1 mb-md-3');
      isOnLastLine ? classNameContainer.add('mb-lg-0') : classNameContainer.add('mb-lg-4');
      if (card.postes_groupe.name === poste) {
        return (
          <div key={index} className={classNameContainer.build()}>
            <CardPlayer
              slug={null}
              title={card.title}
              poste={card.poste.name}
              featured_media={card.featured_media}
              noTextOverflow
            />
          </div>
        );
      } else {
        return false;
      }
    });
  };

  renderCards = () => {
    const { staffs, searchedStaff, staffsFetchStatus } = this.props;

    if (staffsFetchStatus === STATUS_LOADING) {
      return <Loading isWhite />;
    }

    if (staffs && staffs.length > 0) {
      let filteredStaffs = objectFilterTitle(staffs, searchedStaff);

      if (filteredStaffs.length === 0) {
        return (
          <div className="placeholder col col-lg-8on9">
            <p className="ft-h5">
              <i className="icon"></i>Aucun résultat pour cette recherche
            </p>
          </div>
        );
      }

      if (this.state.poste && this.state.poste.length > 0) {
        filteredStaffs = filteredStaffs.filter(staff => {
          return this.state.poste.indexOf(staff.poste.id) !== -1;
        });
      }

      let postes_groupes: Array<any> = [];
      filteredStaffs.forEach(staff => {
        const isObjectPosteExists = postes_groupes.findIndex(poste => poste.name === staff.postes_groupe.name);
        if (isObjectPosteExists === -1) postes_groupes.push(staff.postes_groupe);
      });
      postes_groupes = postes_groupes.map(poste => ({ value: poste.id, label: poste.name, ordre: poste.ordre }));

      return postes_groupes
        .sort((a, b) => {
          return a.ordre - b.ordre;
        })
        .map((poste, index) => {
          return (
            <div key={'poste_' + index} className="row mb-4">
              <div className="players-list">
                <div className="col col-lg-8on9">
                  <h3 className="mb-3">{poste.label}</h3>
                </div>
                <div className="row">
                  <div className="col col-lg-8on9">{this.renderStaffsByPosteGroup(poste.label)}</div>
                </div>
              </div>
            </div>
          );
        });
    } else {
      return (
        <div className="placeholder col col-lg-8on9">
          <p className="ft-h5">
            <i className="icon"></i>Aucun membre de staff.
          </p>
        </div>
      );
    }
  };

  teamChange(team: Object) {
    this.props.history.push(team.link);
  }

  render() {
    const {
      title,
      excerpt,
      status,
      featured_media,
      sidebar_content,
      staffs,
      searchStaff,
      seasons,
      defaultSeason,
      teamlist,
      redirect_competitions,
      redirect_resultats
    } = this.props;
    const { typeRugby, slug } = this.props.match.params;
    if (status === STATUS_LOADING) {
      return <Loading isBlue backgroundColor={'#013974'} />;
    }

    let selectedTeam = false;
    if (teamlist && teamlist.length > 0) {
      selectedTeam = teamlist.filter((team, index) => {
        return team.title === title;
      });
    }

    if (redirect_competitions) {
      teamSubmenuHeaders[3].type_name = 'external';
      teamSubmenuHeaders[3].object_slug = redirect_competitions;
    }

    if (redirect_resultats) {
      teamSubmenuHeaders[2].type_name = 'external';
      teamSubmenuHeaders[2].object_slug = redirect_resultats;
    }

    if (this.props.match.params.slug === 'xv-de-france') {
      teamSubmenuHeaders[7] = {
        menu_order: 35,
        object_slug: '/le-grand-soutien',
        title: 'Le grand soutien',
        description: '',
        featured_media: { src: '' },
        texte_cta: '',
        object_id: 0,
        type_name: 'external'
      };
    }

    /*if (this.props.match.params.slug === 'xv-de-france-masculin') {
      teamSubmenuHeaders[7] = {
        menu_order: 40,
        object_slug: parionsSportLink,
        title: 'Parions Sport',
        description: '',
        featured_media: { src: '' },
        texte_cta: '',
        object_id: 0,
        type_name: 'external'
      };
    }*/

    return (
      <>
        <section className="banner">
          <div className="banner__thumbnail img-blue-dark" style={{ backgroundImage: `url(${featured_media.src})` }} />
          <div className="container">
            <Breadcrumb
              elements={[
                { name: 'accueil', to: '/' },
                { name: 'Équipes de France', to: '/equipe-de-france' },
                { name: title, to: '/equipe-de-france/' + typeRugby + '/' + slug },
                `Le Staff`
              ]}
              isDark
            />
            {teamlist && teamlist.length > 0 && selectedTeam && selectedTeam.length > 0 && (
              <TeamMenuDropdownMenu
                hiddenMenuElements={teamlist}
                isMobile={false}
                id={6}
                level={'h1'}
                activeTeam={selectedTeam[0]}
                switchTeam={this.teamChange.bind(this)}
              />
            )}
            {(!teamlist || teamlist.length === 0) && <h1 className="ft-h2">{title}</h1>}
            {excerpt && <p className="banner__desc">{excerpt}</p>}
          </div>
          <SubMenuHeader
            subMenus={teamSubmenuHeaders}
            subMenuPath={'/equipe-de-france/' + typeRugby + '/' + slug}
            status={STATUS_SUCCESS}
            niveauMenu={4}
          />
        </section>

        <div className="container">
          <div className="row">
            <div className="col col-md-8 col-lg-9 bg-overflow">
              <section>
                <TeamStaffsFilters
                  staffs={staffs}
                  slug={slug}
                  seasons={seasons}
                  defaultSeason={defaultSeason}
                  searchStaff={searchStaff}
                  onFilterChange={(filters, filterType) => this._onFilterChange(filters, filterType)}
                  initialFilters={this.getFiltersOnQuery()}
                />
                {this.renderCards()}
              </section>
            </div>
            <Sidebar sidebarContent={sidebar_content} />
          </div>
        </div>
      </>
    );
  }
}

export default withHelmet(withRouter(TeamStaffs))((Helmet, pageProps) => {
  const {
    title,
    match: { params, url }
  } = pageProps;
  const meta = getMetaBySlug(url, params);
  const ogimage = pageProps.featured_media ? pageProps.featured_media.src : false;
  const ogimagetitle = pageProps.featured_media ? pageProps.featured_media.title : false;

  return (
    <Helmet>
      <title>{meta.title(title)}</title>
      <meta name={'description'} content={meta.description(title)} />
      <meta property={'og:url'} content={window.location.href} />
      <meta property={'og:title'} content={meta.title(title)} />
      <meta property={'og:description'} content={meta.description(title)} />
      {ogimage && <meta property={'og:image'} content={ogimage} />}
      {ogimage && <meta property={'og:image:url'} content={ogimage} />}
      {ogimage && ogimagetitle && <meta property={'og:image:title'} content={ogimagetitle} />}
      <link rel={'canonical'} href={window.location.href} />
    </Helmet>
  );
});
